import { Box, Grid } from '@material-ui/core';
import { getPayoutSummaryById } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router';

import { LenderSummaryDetails } from '@/components/modules/Payouts/PayoutDetails/PayoutDetailsOverview/components/LenderSummaryDetails';
import { PayoutSummaryDetails } from '@/components/modules/Payouts/PayoutDetails/PayoutDetailsOverview/components/PayoutSummaryDetails';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { PendingDataType } from '@/config/types';
import { useCache } from '@/hooks/requests/useCache';
import { useSetPageLoadingWhenRequesting } from '@/hooks/requests/useSetPageLoadingWhenRequesting';
import { useScreen } from '@/hooks/useScreen';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const PayoutDetailsOverview = () => {
  const { payoutId } = useParams();

  if (!payoutId) return null;

  const { data: payoutSummary, loading } = useCache(getPayoutSummaryById, { id: payoutId });

  const { isMobile } = useScreen();

  useSetPageLoadingWhenRequesting('PAYOUT_SUMMARY', [loading]);

  if (!payoutSummary) return <PendingDataWarning type={PendingDataType.PAYOUT_DETAILS} />;

  return (
    <Box pt={2}>
      <Grid container spacing={6} className="appear-anim">
        <Grid item xs={isMobile ? 12 : 6}>
          <PayoutSummaryDetails payoutSummary={payoutSummary} />
        </Grid>
        <Grid item xs={isMobile ? 12 : 6}>
          <LenderSummaryDetails payoutSummary={payoutSummary} />
        </Grid>
      </Grid>
    </Box>
  );
};

export const PayoutDetailsOverviewModule = withPermissionsModule(PayoutDetailsOverview);
